<app-form-editor-section-header *ngIf="procedureForm() as procedureForm"
    [loaded]="loaded" [loadingHttp]="loadingHttp" [procedureForm]="procedureForm"
    (back)="goBack()" (restoreState)="restoreState($event)" (showSectionSelector)="showSectionSelector($event)" (showPreview)="showPreview()">
</app-form-editor-section-header>

<as-split [direction]="'horizontal'" [gutterSize]="6" unit="pixel" [hidden]="!loaded()">

    <as-split-area size="*">

        <div class="d-flex" [class.dd-zone]="ddWidget" cdkDropListGroup>
            
            <div class="tool-detail-work-area work-area body-container-all" style="width: 411px; min-width: 290px; ">
                
                <app-page-scroll-content>
                    <app-form-editor-section-tools (startDrag)="onStartDrag($event)"
                        (endDrag)="onEndDrag($event)" (changeItem)="onSectionChange($event)"
                        (addTool)="onAddTool($event)">

                    </app-form-editor-section-tools>
                </app-page-scroll-content>

            </div>

            <div class="work-area body-container-all" style="flex:1 0 0;" (click)="onSelectedSection(true)">

                <div class="d-flex align-items-center" style="height: 48px;">

                    <div *ngIf="viewInitiated" class="mat-body-1" style="padding-left: 16px; padding-top: 24px; padding-bottom: 4px;">Linies disponibles
                        ({{availableLines()}})
                    </div>

                </div>
                
                <app-page-scroll-content>
                    <app-form-editor-section-layout
                        (createdLayout)="onSectionChangeWithRefresh(sectionService.createdLayout($event));detailComponent.selectToolTab();"
                        (movedLayout)="onSectionChangeWithRefresh(sectionService.movedLayout($event));detailComponent.selectToolTab();"
                        (createdRow)="onSectionChange(sectionService.createdRow($event),false);detailComponent.selectToolTab();"
                        (movedRow)="onSectionChangeWithRefresh(sectionService.movedRow($event));detailComponent.selectToolTab();"
                        (removedRow)="onSectionChange(sectionService.removedRow($event));detailComponent.selectToolTab();"
                        (removedWidget)="onSectionChange(sectionService.removedWidget($event));detailComponent.selectToolTab();"
                        (movedWidget)="onSectionChange(sectionService.movedWidget($event))"
                        (createdWidget)="onSectionChange(sectionService.createdWidget($event))"
                        (transferredWidget)="onSectionChange(sectionService.transferredWidget($event),false);previewComponent.clean()"
                        (selectedWidget)="onSelectedWidget($event);previewComponent.clean()"
                        (selectedRow)="onSelectedRow($event)" 
                        (selectedLayout)="onSelectedLayout($event)"
                        (selectedSection)="onSelectedSection($event)"
                        (requestAddTool)="onRequestAddTool($event)"
                        (recordOnHistory)="onRecordOnHistory($event)">

                    </app-form-editor-section-layout>
                </app-page-scroll-content>
                
            </div>

        </div>

    </as-split-area>
    
    <as-split-area [size]="866" [minSize]="410" [maxSize]="866">
        <div class="preview-area body-container-all">
            <app-page-scroll-content (scroll)="onScroll($event)">
                
                <app-form-editor-section-preview [section]="sectionService.sectionMetadata">

                </app-form-editor-section-preview>

            </app-page-scroll-content>
        </div>
    </as-split-area>

</as-split>
